// Polyfill for React 19 compatibility with Material-UI v4
import './findDOMNodePolyfill';

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './ServiceWorker';

// Silence console output (logs, warnings, errors, etc.) so nothing shows up
// in the browser devtools when the user inspects the page.
if (typeof window !== 'undefined' && window.console) {
    const noop = () => {};
    const methodsToSilence = [
        'log',
        'info',
        'debug',
        'warn',
        'error',
        'trace',
        'table',
        'dir',
        'group',
        'groupCollapsed',
        'groupEnd',
        'time',
        'timeEnd',
        'timeLog',
        'count',
        'countReset',
        'assert',
    ];
    methodsToSilence.forEach((method) => {
        if (typeof window.console[method] === 'function') {
            window.console[method] = noop;
        }
    });
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();

